import { CustomerRequestType, CustomerRequestStatus } from '~/supabase/types'

export const customerRequestTypes = [
  'order',
  'repair',
  'resize',
  'wish',
  'waitlist',
] as const satisfies CustomerRequestType[]

export const customerRequestStatuses = [
  'complete',
  'failed',
  'pending',
  'ready',
] as const satisfies CustomerRequestStatus[]
